import { createContext } from 'react';

import CoreBusy from './service';

const CoreBusyContext = createContext(CoreBusy);

export { CoreBusy as Context };
export default CoreBusyContext;
